export default "__VITE_ASSET__CmGr2Fvz__"